import { Link, Text } from '@chakra-ui/react';
import { usePaymentStatus } from '@utils/hooks/queries';
import { useIsMobile } from '@utils/hooks/useIsMobile';
import { AnimatePresence } from 'motion/react';
import { MotionBox } from '@components/ui/motion';
import { slideFromTop } from '@utils/motion';

const PaymentFailedBanner = () => {
  const isMobile = useIsMobile();
  const { paymentFailed, invoiceUrl } = usePaymentStatus();

  const show = paymentFailed;

  return (
    <AnimatePresence>
    {show && (
    <MotionBox
      key="payment-failed-banner"
      variants={slideFromTop}
      initial="initial"
      animate="animate"
      exit="exit"
      position="fixed"
      top={0}
      left={0}
      right={0}
      zIndex={isMobile ? 100: 9999}
      bg="red.500"
      color="white"
      py={3}
      px={5}
      boxShadow="lg"
      textAlign="center"
      whiteSpace="wrap"
    >
      <Text fontSize="sm" fontWeight="medium">
        Ton dernier paiement n'est pas passé. Pour conserver ton accès → {' '}
        {invoiceUrl ? (
          <Link href={invoiceUrl} target="_blank" rel="noopener noreferrer" textDecoration="underline" fontWeight="bold" color="white">
            régularise ton compte
          </Link>
        ) : (
          <Text as="span" fontWeight="bold">régularise ton compte </Text>
        )}
      </Text>
    </MotionBox>
    )}
    </AnimatePresence>
  );
};

export default PaymentFailedBanner;
